export const UserStatusType = {
  EXPLORER: 'EXPLORER',
  VIVINAUT: 'VIVINAUT',
};

export const userStatusTypes = [UserStatusType.EXPLORER, UserStatusType.VIVINAUT];
